import {
  AssessmentFieldSchema,
  ReturnAssessmentDefinitionSchema,
  ReturnAssessmentSchema,
} from "@redotech/redo-return-core-common/return-assessments/assessment-schemas";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createAssessment = {
  name: "createAssessment" as const,

  input: z.object({
    name: z.string().min(1, "Assessment name is required"),
    kind: createEnum(ReturnTypeEnum),
    fields: z.array(AssessmentFieldSchema).optional().default([]),
    iconName: z.string().min(1).optional(),
    iconColor: z.string().min(1).optional(),
  }),

  output: z.object({
    schema: ReturnAssessmentSchema,
    definition: ReturnAssessmentDefinitionSchema,
  }),
};
